// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { auditEventsResponseSchema } from '@/audit/api/types';

/**
 * Request a list of audit events for a customer from the remote API.
 *
 * @param key - The key of the customer for which to request audit events.
 */
export async function getCustomerAuditEvents(key: string) {
  const url = `/v1/customer/${key}/audit`;
  const response = await api.get(url);

  return parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'CustomerAuditEvents',
    endpoint: url,
  });
}
